module.exports = __webpack_public_path__ + "static/back-1c3bbc3600934c29d59eadc1d06f7f7f.mp4";